import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@gigpro/ui/Collapsible";
import { ChevronDown, Star } from "@gigpro/ui/Icons";
import { Skeleton } from "@gigpro/ui/Skeleton";
import React from "react";
import { times } from "remeda";

type PROfileGigHistorySummaryProps = {
  count: number;
  entries: Record<
    string,
    { skillId: number; count: number; avgRating: number; avgWage: number; detail: React.ReactNode }
  >;
  expandable: boolean;
};
export const PROfileGigHistorySummary: React.FC<PROfileGigHistorySummaryProps> = ({
  count,
  entries: data,
  expandable,
}) => (
  <>
    <h2 className="profile-title text-large font-semibold @sm/profile:text-extraLarge">Shift History</h2>
    {count > 0 ? (
      <div className="flex flex-col gap-5 @sm/profile:gap-6">
        <p className="profile-title -mb-2 text-gray @sm/profile:text-large">{count} shifts worked to date</p>
        {Object.entries(data).map(([skill, { skillId, count, avgRating, avgWage, detail }]) => (
          <Collapsible key={skillId} disabled={!expandable}>
            <CollapsibleTrigger
              className="grid w-full grid-cols-[1fr_min-content] place-items-start data-[state=open]:[&>svg]:rotate-180"
              data-testid={`positionsummary_${skill}`}
            >
              <p className="font-semibold">
                {skill} ({count})
              </p>
              {expandable ? <ChevronDown className="text-brand transition-transform" /> : <div />}
              <p className="flex items-center gap-1 truncate">
                <Star className="size-4 text-warning" /> <b>{avgRating.toFixed(1)}</b> Avg. Star Rating |{" "}
                <b>${avgWage.toFixed(0)}</b> Avg. hourly rate
              </p>
            </CollapsibleTrigger>
            <CollapsibleContent data-testid={`positionhistory_${skill}`}>{detail}</CollapsibleContent>
          </Collapsible>
        ))}
      </div>
    ) : (
      <p className="mt-2 text-medium-gray">This pro hasn't worked any shifts yet</p>
    )}
  </>
);

export const PROfileGigHistorySummarySkeleton: React.FC = () => (
  <>
    <h2 className="profile-title text-large font-semibold @sm/profile:text-extraLarge">Shift History</h2>
    <div className="flex flex-col gap-5 @sm/profile:gap-6">
      <Skeleton className="-mb-2 w-40 text-normal @sm/profile:text-large" />
      {times(3, (index) => (
        <React.Fragment key={index}>
          <div className="grid grid-cols-[1fr,min-content]">
            <Skeleton className="w-16 text-normal" />
            <Skeleton variant="circle" className="size-4" />
            <p className="flex gap-1">
              <Skeleton variant="circle" className="size-4" />
              <Skeleton className="w-20" />
            </p>
          </div>
        </React.Fragment>
      ))}
    </div>
  </>
);
